import type { Layout } from '@swf/core/types/Layout';
import type { WidgetContainer } from '@swf/core/types/Widget';

export const flattenWidgets = (layout: Layout): WidgetContainer[] => {
  let list: WidgetContainer[] = [];
  Object.values(layout.sections).forEach((section) => {
    if (section.widgets) {
      list = list.concat(section.widgets);
    } else if (section.layout) {
      list = list.concat(flattenWidgets(section.layout));
    }
  });
  return list;
};
